/**
 * Admin Quote Detail hydration helpers.
 *
 * Msg 241 (2026-02-22) — the backend `POST /admin/quotes/{id}/mark-read`
 * returns the RAW `quote_activities` document (no `price_breakdown`,
 * no `finalization`, no `linked_order`, no `update_email_status`).
 * The frontend previously overwrote the enriched detail with the raw
 * doc, so the editable Price Breakdown vanished on FIRST open. This
 * helper merges only the small lifecycle fields the mark-read
 * response is authoritative for — everything else must survive.
 *
 * Pure so we can lock the behaviour with Jest.
 */

/**
 * Merge the mark-read response back onto an enriched quote in-place-safely.
 * Returns a new object; never mutates inputs.
 *
 * @param {Object|null} prev - the enriched quote currently in state
 * @param {Object|null} mrResp - the raw quote_activities doc returned by /mark-read
 * @returns {Object|null}
 */
export function mergeMarkReadResponse(prev, mrResp) {
  if (!prev) return prev;
  if (!mrResp) return prev;
  return {
    ...prev,
    admin_read:       true,
    status:           mrResp.status || prev.status,
    updated_at:       mrResp.updated_at || prev.updated_at,
    last_activity_at: mrResp.last_activity_at || prev.last_activity_at,
  };
}
